import * as React from 'react';
import * as styles from './message.scss';
import { connect } from 'react-redux';
import { Grid, Col } from 'components/grid';
import * as colStyles from 'components/grid/col.scss';
import ArrowRight from 'components/svg/ArrowRight';
import SVGClose from 'components/svg/Close';
import {showGlobalMessage} from 'store/global/globalActions';


type Props = {
    messageType?: any;
    closeMessage?: any;
}

type State = {
    global:any;
};

export const MESSAGE_TYPES = {
    WARNING: 'MESSAGE_TYPE_WARNING',
    INFO: 'MESSAGE_TYPE_INFO',
    HIDDEN: 'MESSAGE_TYPE_HIDDEN',
};

class Message extends React.Component<Props, any> {
    public constructor(props:Props) {
        super(props);
    }


    public getClassNames = (messageType:string):string => {
        return messageType === MESSAGE_TYPES.INFO ? styles.globalInfoMessage : '';
    };

    public onCloseClicked = () => {
        this.props.closeMessage();
    };

    public render() {
        const message = 'From April 3 till April 5th there might occure some unpredicted downtimes due to maintenance work';
        const buttonLabel = 'See more';
        const {
            messageType,
            } = this.props;
        const visible = messageType !== MESSAGE_TYPES.HIDDEN;

        return (
                <>
            {(visible) &&
            <div className={styles.globalMessage + ' ' + this.getClassNames(messageType)}>
                <Grid>
                    <Col
                        className={colStyles.col7Md + ' ' + colStyles.col8DtL}
                    >

                        <p>{message}</p>
                    </Col>
                    <Col
                        className={colStyles.col5Md + ' ' + colStyles.col4DtL}
                    >
                        <a>
                            <span>{buttonLabel}</span>
                            <ArrowRight />
                        </a>
                    </Col>
                </Grid>
                <button
                    onClick={this.onCloseClicked}
                >
                    <SVGClose />
                </button>
            </div>
                }
        </>);
    }
}

const mapStateToProps = (state:State) => {
    const messageType = state.global.globalMessageType;
    return {
        messageType
    };
};

const mapDispatchToProps = (dispatch:any, ownProps:Props) => ({
    closeMessage: () => {
        dispatch(showGlobalMessage(MESSAGE_TYPES.HIDDEN));
    }
});


export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Message as any);